import { Component, NgModule, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Right } from 'app/entities/transaction-profile/right.model';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { AddRightComponent } from 'app/entities/transaction-profile/rights/addright/add-right.component';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { Agreement } from 'app/entities/transaction-profile/agreement.model';

@Component({
    selector: 'rights',
    templateUrl: './right.component.html'
})

export class RightComponent implements OnInit, OnDestroy {
    @Input() entityIdDetails: EntityIdDetails;
    rights: Array<Right>;
    dialogRef: MdDialogRef<any>;
    selectedRight: Right;
    isLoading = false;
    selectedAgreement: Agreement;
    zeroAggrement = true;
    private subscriptions: Subscription[] = [];

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        public  snackBarService:  SnackBarService,
        private transactionProfileService: EntityTransactionProfileService) { }

    ngOnInit() {
        this.setSelectedAgreementSubscriber();
    }

    setSelectedAgreementSubscriber() {
        // Unsubscribe from previous subscription if it exists
        const existingSub = this.subscriptions.find(sub => sub && !sub.closed);
        if (existingSub) {
            existingSub.unsubscribe();
        }
        
        this.isLoading = true;
        const subscription = this.transactionProfileService.selectedAgreement.subscribe(agreement => {
            if (agreement) {
                this.selectedAgreement = agreement;
                this.loadRightsDetails();
                this.zeroAggrement = false;
            }else {
                this.isLoading = false;
            }
        });
        this.subscriptions.push(subscription);
    }

    loadRightsDetails() {
        this.isLoading = true;
        const subscription = this.transactionProfileService.getRights(this.selectedAgreement.id)
            .subscribe(response => {
                this.rights = response;
                this.isLoading = false;
            });
        this.subscriptions.push(subscription);
    }

    editRigth(right: Right) {
        this.selectedRight = right;
        this.openAddRightDialog('Edit');
    }

    removeRigth(right: Right) {
        this.isLoading = true;
        const subscription = this.transactionProfileService.removeRight(right.id)
            .subscribe(response => {
            this.loadRightsDetails();
            this.callSnackBarService(response, MessageService.RIGHT_DELETE_SUCCESS, '');
        }, err => {
            this.callSnackBarService(err, '', MessageService.RIGHT_DELETE_FAILUR);
        });
        this.subscriptions.push(subscription);
    }

    openAddRightDialog(action: string) {
        const config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddRightComponent, config);
        this.dialogRef.componentInstance.selectedRight = this.selectedRight;
        this.dialogRef.componentInstance.entityIdDetails = this.entityIdDetails;
        this.dialogRef.componentInstance.agreementId = this.selectedAgreement.id;
        this.dialogRef.componentInstance.action = action;
        const subscription = this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadRightsDetails();
            }
            this.dialogRef = null;
            this.selectedRight = null;
            //setTimeout(() => { this.getGroupList() }, 2000)
        });
        this.subscriptions.push(subscription);
    }

    callSnackBarService(response: any, success: string, failur: string) {
        this.isLoading = false;
        this.snackBarService.showStatus(response, success, failur);
    }

    ngOnDestroy() {
        // Unsubscribe from all subscriptions to prevent memory leaks and duplicate calls
        this.subscriptions.forEach(sub => {
            if (sub && !sub.closed) {
                sub.unsubscribe();
            }
        });
        this.subscriptions = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/rights/right.component.ts